import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from '../../components/ui/FormField';
import type { SchemaFieldProps } from '../types';

/**
 * Custom SchemaForm widget for an event template's `recurringPattern`. The
 * default enum widget prepends a blank "Select…" option, but this field is
 * always seeded ('weekly') and never empty, so this override renders the four
 * concrete options only — matching the legacy EventTemplateForm select exactly.
 */
const PATTERNS: Array<{ value: string; labelKey: string }> = [
  { value: 'daily', labelKey: 'templates.daily' },
  { value: 'weekly', labelKey: 'templates.weekly' },
  { value: 'biweekly', labelKey: 'templates.biweekly' },
  { value: 'monthly', labelKey: 'templates.monthly' },
];

const RecurringPatternField: React.FC<SchemaFieldProps> = ({ field, value, onChange, error }) => {
  const { t } = useTranslation();

  return (
    <FormField
      htmlFor="sf-recurringPattern"
      label={t(field.labelKey, field.name)}
      required={field.required}
      error={error}
    >
      <select
        id="sf-recurringPattern"
        value={value ?? 'weekly'}
        onChange={(e) => onChange(e.target.value)}
      >
        {PATTERNS.map((p) => (
          <option key={p.value} value={p.value}>
            {t(p.labelKey)}
          </option>
        ))}
      </select>
    </FormField>
  );
};

export default RecurringPatternField;
